module.exports = __webpack_public_path__ + "static/testimonial-thumb-2-6999f587569e10ab0d999eb8498ee6d5.jpg";